export default "__VITE_ASSET__C9_LSh9v__"